module.exports = __webpack_public_path__ + "img/alta.5e9fcd98.png";